import bannerReferral from '@/assets/images/banner/banner-referral.webp';
import bannerGuide from '@/assets/images/banner/banner-guide.webp';
import bannerEf from '@/assets/images/banner/banner-ef.webp';
import { resolveAdCompanyCarouselBanners } from '@/components/shared/ad-banner/adCompanyBanners';
import type { BannerConfig, FeaturedBannerPayload } from './types';

const FEATURED_BANNER_GLOBAL_KEY = '__FEATURED_BANNER__';

export const DEFAULT_AUTOPLAY_DELAY_MS = 2000;

/**
 * Rails 側で埋め込まれることを想定した featured_banner を取得する。
 * 未提供の場合は undefined を返し、他の静的バナーのみ表示する。
 */
export const resolveFeaturedBanner = (): BannerConfig | undefined => {
  if (typeof window === 'undefined') return undefined;

  const payload = (window as unknown as Record<string, FeaturedBannerPayload>)[
    FEATURED_BANNER_GLOBAL_KEY
  ];
  if (!payload?.image_path || !payload?.link_url) return undefined;

  return {
    id: 'featured-banner',
    imageUrl: payload.image_path,
    alt: payload.company_name ? `${payload.company_name} 広告バナー` : '広告バナー',
    linkUrl: payload.link_url,
    linkTarget: payload.link_target,
    linkRel: payload.link_rel,
  };
};

const adCompanyBanners: BannerConfig[] = resolveAdCompanyCarouselBanners();

const staticBanners: BannerConfig[] = [
  {
    id: 'referral',
    imageUrl: bannerReferral,
    alt: 'お友達紹介のご案内',
    modalTarget: '#referralModal',
    ariaLabel: 'お友達紹介のご案内を開く',
  },
  {
    id: 'job-change-guide',
    imageUrl: bannerGuide,
    alt: '職務経歴書の書き方',
    linkUrl: 'https://se-navi.jp/media/job-change/',
    linkTarget: '_blank',
    linkRel: 'noopener noreferrer',
  },
  {
    id: 'freelance-offer',
    imageUrl: bannerEf,
    alt: 'フリーランス副業案件ならエンジニアファクトリー',
    linkUrl: 'https://www.engineer-factory.com',
    linkTarget: '_blank',
    linkRel: 'noopener noreferrer',
  },
  {
    id: 'fair-6293',
    imageUrl: 'https://se-navi.jp/media/wp-content/uploads/6293_ec.png',
    alt: 'IT・Web業界 転職フェア開催中',
    linkUrl: 'https://se-navi.jp/media/6293/',
    linkTarget: '_blank',
    linkRel: 'noopener noreferrer',
  },
  {
    id: 'engineer-6885',
    imageUrl: 'https://se-navi.jp/media/wp-content/uploads/6885_ec.png',
    alt: '未経験から目指すエンジニア特集',
    linkUrl: 'https://se-navi.jp/media/6885/',
    linkTarget: '_blank',
    linkRel: 'noopener noreferrer',
  },
];

/** 広告バナー（全件）＋その他の静的バナー。featured は BannerCarousel 側で先頭に結合する */
export const defaultBanners = [...adCompanyBanners, ...staticBanners];
